import React from 'react';
import { IconSaxIcon } from '@/components/design-system/atoms/icon';
import { composeClassName } from '@/utils/util_helpers';

interface NavButtonProps {
  direction: 'left' | 'right';
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  ariaLabel?: string;
  iconSize?: number;
  iconStrokeWidth?: number;
  style?: React.CSSProperties;
  stopPropagation?: boolean;
}

const NavButton: React.FC<NavButtonProps> = ({
  direction,
  onClick,
  className = '',
  ariaLabel,
  iconSize = 20,
  iconStrokeWidth,
  style,
  stopPropagation = false,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (stopPropagation) e.stopPropagation();
    onClick(e);
  };
  const baseClass =
    'z-10 flex h-6 w-6 items-center justify-center rounded-[24px] bg-white p-[11.43px] shadow-md border-[1px] border-[#CED4DA]';
  const positionClass = direction === 'left' ? 'left-0' : direction === 'right' ? 'right-0' : '';
  return (
    <button
      type="button"
      onClick={handleClick}
      className={composeClassName(baseClass, positionClass, className)}
      aria-label={ariaLabel || (direction === 'left' ? 'Previous' : 'Next')}
      style={style}
    >
      <IconSaxIcon
        name={direction === 'left' ? 'arrow-left' : 'arrow-right'}
        size={iconSize}
        {...(iconStrokeWidth ? { strokeWidth: iconStrokeWidth } : {})}
      />
    </button>
  );
};

export default NavButton;
